import { Component, inject } from '@angular/core';
import { PortalTheme } from '@app/@shared/models';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';
import { TransactionsTableComponent } from '@app/areas/transactions/components';

@Component({
  template: '<app-transactions-table [theme]="theme"/>',
  styleUrls: ['./transactions.component.scss'],
  imports: [TransactionsTableComponent],
  standalone: true,
})
export class TransactionsComponent {
  protected theme!: PortalTheme;
  private readonly applicationProfileService = inject(ApplicationProfileService);

  ngOnInit(): void {
    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
